module.exports = __webpack_public_path__ + "img/横向中线对齐.a931ef5e.svg";